// extracted by mini-css-extract-plugin
module.exports = {"quizPage":"QuizPage-module--quizPage--2HAfy","container":"QuizPage-module--container--33tQp","frame":"QuizPage-module--frame--3CCwg"};